
// FILE: src/service/MenuService.js
function MenuService(ScreenService, Query, ZhUtil, RepositoryFactory, eventEngine, templateManager) {

	const self = this;
	const MENU_ITEM_ID = "CDPRODUTO";
	const QTD_ITEM = "QUANTIDADE";

	this.selectedProduct = null;
	this.cart = [];

	this.addToCart = function(menuWidget) {
		const promise = new Promise((resolve, reject) => {
			let product = self.selectedProduct;
			if (product) {
				if (product.IDTIPOCOMPPROD == '3' || product.IDTIPOCOMPPROD == 'C') {
					// Adding combo product
					if (_isComboCartFilled(product.comboCart)) {
						let existentComboData = _getExistentComboInCart(product, this.cart);
						if(existentComboData.exist){
							let alreadyExistentProduct = this.cart[existentComboData.productIndex];
							alreadyExistentProduct[QTD_ITEM] += product[QTD_ITEM];
						} else {
							this.cart.push(product);
						}
						self.updateCartHint(templateManager.container.getWidget('menu'));
						resolve(product);
						ScreenService.closePopup(true);
					} else {
						reject('Preencha todos os itens para prosseguir.');
					}
				} else if (product.parentProduct) {
					// Adding product from combo
					let currentComboCart = menuWidget.parentWidget.product.comboCart[product.parentComboItem];
					if ((self.getTotalCurrentComboProducts(currentComboCart.products) + product.QUANTIDADE) <= currentComboCart.QTPRGRUPPROMOC) {
						currentComboCart.products.push(product);
						resolve(product);
					} else {
						reject('Quantidade de produtos para o grupo excedida.');
					}
					// Resets selected product to combo again
					self.selectedProduct = menuWidget.parentWidget.product;
					ScreenService.closePopup();

					// Checks if cart is filled to add combo automatically and improve ux
					_performAutomaticSelect(currentComboCart, menuWidget);
				} else {
					// Adding normal product
					let cartItemCode = product[MENU_ITEM_ID];
					let existentProductData = _getExistentProductInCart(cartItemCode, this.cart);
					if (existentProductData.exist) {
						let alreadyExistentProduct = this.cart[existentProductData.productIndex];
						alreadyExistentProduct[QTD_ITEM] += product[QTD_ITEM];
					} else {
						this.cart.push(product);
					}

					self.updateCartHint(templateManager.container.getWidget('menu'));
					resolve(product);
					ScreenService.closePopup();
				}
			} else {
				reject('Erro ao adicionar o item ao carrinho. Confira se os parametros utilizados no template estão de acordo com a documentação.');
			}
		});
		return promise;
	};

	const _performAutomaticSelect = (comboCart, menuWidget) => {		
		const totalComboLength = comboCart.QTPRGRUPPROMOC;
		const comboCartLength = this.getTotalCurrentComboProducts(comboCart.products);

		if (parseFloat(totalComboLength) === comboCartLength) {
			this.addToCart(menuWidget);
		}
	};

	this.getTotalPrice = function() {
		let totalPrice = 0;
		this.cart.forEach(function(cartItem) {
			if(cartItem.IDTIPOCOMPPROD == '3' || cartItem.IDTIPOCOMPPROD == 'C'){
				totalPrice += self.calculateComboPrice(cartItem);
			} else {
				totalPrice += cartItem.QUANTIDADE * parseFloat(cartItem.VRPRECITEM);
			}
		});
		return totalPrice;
	};

	this.calculateComboPrice = function(combo) {
		let totalComboPrice = 0;

		for (let i in combo.comboCart) {
			combo.comboCart[i].products.forEach((comboItem, index) => {
				totalComboPrice += comboItem.QUANTIDADE * parseFloat(comboItem.VRPRECITEM);
		    });
		}

		return totalComboPrice;
	};

	this.getCart = function() {
		return this.cart;
	};

	this.updateCartHint = function(menuWidget) {
		const cartAction = menuWidget.getAction('cart');
		if (cartAction) {
			cartAction.hint = this.cart.length;
		}
	};

	this.clearCart = function() {
		this.cart = [];
	};

	this.removeCartItem = function(cartItemCode) {
		this.cart.some((item, index) => {
			if (item.CDPRODUTO === cartItemCode) {
				this.cart.splice(index, 1);
				return true;
			}
			return false;
		});
	};

	this.updateCart = function(cart) {
		this.cart = cart;
	};

	this.getFullComboCode = function(item){
		let itemCode = item.CDPRODUTO;

		for(let i in item.comboCart) {
			item.comboCart[i].products.forEach(function(comboItem, index){
				itemCode += comboItem.CDPRODUTO;
		    });
		}

		return itemCode;
	};

	this.getProductObservations = function(item) {
		return item.personalizations.observations.filter(function(observation){
			return observation.selected;
		});
	};

	this.getTotalCurrentComboProducts = function(products) {
		let total = 0;
		products.forEach(function(product) {
			total += product.QUANTIDADE;
		});
		return total;
	};

	let _getExistentProductInCart = function(cartItemCode, menuCart) {
		let productIndex;
		let exist = menuCart.some(function(item, index) {
			if (item.CDPRODUTO == cartItemCode) {
				productIndex = index;
				return true;
			}
		});

		return {
			'exist': exist,
			'productIndex': productIndex
		};
	};

	let _getExistentComboInCart = function(combo, menuCart){
		let comboCode = self.getFullComboCode(combo);
		let productIndex, itemCode;
		let exist = menuCart.some(function(item, index) {
			if(item.IDTIPOCOMPPROD == '3' || item.IDTIPOCOMPPROD == 'C'){
				itemCode = self.getFullComboCode(item);
				if (itemCode == comboCode) {
					productIndex = index;
					return true;
				}
			}
		});

		return {
			'exist': exist,
			'productIndex': productIndex
		};
	};

	let _isComboCartFilled = function(comboCart) {
		let isFilled = true;
		Object.keys(comboCart).forEach(function(cartKey) {
			let currentCombo = comboCart[cartKey];
			if (self.getTotalCurrentComboProducts(currentCombo.products) < currentCombo.QTPRGRUPPROMOC) {
				isFilled = false;
			}
		});
		return isFilled;
	};
}
Configuration(function(ContextRegister) {
	ContextRegister.register('MenuService', MenuService);
});


// FILE: src/controller/MenuTemplateController.js
function MenuTemplateController($scope, eventAggregator, ScreenService, ApplicationContext) {

	const widget = $scope.widget;

	this.buildMenu = function() {
		_bindWatcherForProducts();
		_loadTemplateStyle();
	};

	const _bindWatcherForProducts = function() {
		let menuData = [];
		$scope.$watch("widget.menuProducts", function() {
			if (widget.menuProducts) {
				Object.keys(widget.menuProducts).forEach(function(menuKey) {
					let currentMenu = widget.menuProducts[menuKey];

					if (!currentMenu.subgrupos) {
						currentMenu.subgrupos = [
							{
								CODIGO: currentMenu.CODIGO,
								DESC: currentMenu.DESC,
								products: []
							}
						];

						let menuProducts = [];
						Object.keys(currentMenu.produtos).forEach(function(productKey) {
							let currentProduct = currentMenu.produtos[productKey];
							if(currentProduct.IDTIPOCOMPPROD !== 'C'){
								currentProduct.personalizations = _buildProductPersonalizations(currentProduct.OBSERVACOES);
							} else {
								for (let i in currentProduct.GRUPOS.produtos) {
									currentProduct.GRUPOS.produtos[i].personalizations = _buildProductPersonalizations(currentProduct.GRUPOS.produtos[i].OBSERVACOES);
								}
							}
							menuProducts.push(currentProduct);
						});

						currentMenu.subgrupos[0].products = menuProducts;
					}

					// Filter groups to don't repeat them on menu data
					let groupIndex = menuData.findIndex(menuGroup => menuGroup.grupo.CODIGO == currentMenu.grupo.CODIGO);

					if (groupIndex === -1) {
						menuData.push(currentMenu);
					} else {
						menuData[groupIndex] = currentMenu;
					}
				});
			}
			widget.dataSource.data = menuData;
        });
	};

	const _loadTemplateStyle = function() {
		$scope.templateColors = {
			group: {
				'color': widget.menuProperties.colors.group.text,
				'background-color': widget.menuProperties.colors.group.background
			},
			openedGroup: {
				'color': widget.menuProperties.colors.group.opened.text,
				'background-color': widget.menuProperties.colors.group.opened.background,
				'border-left': `3px solid ${widget.menuProperties.colors.group.opened.text}`
			}
		};
	};

	const _buildProductPersonalizations = function(personalizationsArray) {
		let productPersonalizations = {
			ingredients: [],
			observations: [],
			customObservation: ''
		};

		if (widget.personalizations.length) {
			personalizationsArray.forEach(function(personalizationCode){
				let observation = widget.personalizations.filter(function(observation){
					observation.selected = false;
					return observation.CDOCORR == personalizationCode;
				}).shift();

				if (observation.IDCONTROLAOBS == 'A') {
					if (observation.CDPRODUTO) {
						if (parseFloat(observation.VRPRECITEM) === 0) {
							observation.VRPRECITEM = 0.1;
						}
						let _ingredient = angular.copy(observation);
						productPersonalizations.ingredients.push(_ingredient);
					}
				} else {
					let _observation = angular.copy(observation);
					productPersonalizations.observations.push(_observation);
				}
			});
		}
		return productPersonalizations;
	};

	this.collapseProducts = function(group) {
		if (group.opened) {
			group.opened = !group.opened;
		} else {
			group.opened = true;
		}
	};

	// Select product PopUp
	this.selectProduct = function(product) {
		let template, showAsModal;
		if (product.IDTIPOCOMPPROD == '3' || product.IDTIPOCOMPPROD == 'C') {
			template = 'odh-menu#combo-menu.html';
			showAsModal = true;
			product.menuGroups = _getBuiltComboGroups(product);
		} else {
			template = 'odh-menu#product-detail.html';
			showAsModal = false;
			product.menuGroups = [];
		}

		let selectedProductActions = [
			{
				"label": "Cancelar",
				"showAsAction": "back",
				"isVisible": true,
				"showOnForm": true,
				"showOnList": true,
				"hideIcon": true,
				"events": [
					{
						"name": "ActionEvent",
						"code": "ScreenService.closePopup();",
					}
				]
			},
			{
				"label": "Adicionar",
				"showAsAction": "never",
				"isVisible": true,
				"showOnForm": true,
				"showOnList": true,
				"events": [
					{
						"name": "ActionEvent",
						"code": widget.menuProperties.events.addToCart
					}
				]
			}
	    ];

		let popupWidget = metaDataFactory.widgetFactory({
			"name": "selectedProduct",
			"container": widget.container,
			"parentWidget": widget,
			"label": "Personalize seu produto",
			"template": template,
			"showAsModal": showAsModal,
			"isVisible": true,
			"popupNoBlock": false,
			"actions": selectedProductActions,
			"product": product,
			"menuProperties": widget.menuProperties
		});

		product.QUANTIDADE = 1;
		ScreenService.openPopup(popupWidget);
		ApplicationContext.MenuService.selectedProduct = product;
	};

	const _getBuiltComboGroups = (product) => {
		let _groups = [];
		if (!product.comboCart) {
			product.comboCart = {};
		}
		Object.keys(product.GRUPOS).forEach((groupKey, idx, groups) => {
			let group = product.GRUPOS[groupKey].grupo;
			let products = [];

			Object.keys(product.GRUPOS[groupKey].produtos).forEach(function(productKey) {
				let currentProduct = product.GRUPOS[groupKey].produtos[productKey];
				currentProduct.personalizations = _buildProductPersonalizations(currentProduct.OBSERVACOES);
				currentProduct.parentProduct = product.CDPRODUTO;
				currentProduct.parentComboItem = group.CDGRUPROMOC;
				products.push(currentProduct);
			});

			product.comboCart[group.CDGRUPROMOC] = {
				'QTPRGRUPPROMOC': group.QTPRGRUPPROMOC,
				'products': []
			};

			_groups.push({
				'grupo': group,
				'products': products,
				'opened': groups.length === 1
			});
		});

		return _groups;
	};

	this.getRemainingProductsMessage = function(group) {
		const comboCart = widget.product.comboCart[group.grupo.CDGRUPROMOC];
		
		const totalComboLength = comboCart.QTPRGRUPPROMOC;
		const comboCartLength = ApplicationContext.MenuService.getTotalCurrentComboProducts(comboCart.products);

		return `${comboCartLength}/${totalComboLength}`;
	};

	this.getRemainingProductsLength = (group) => {
		let comboCart = widget.product.comboCart[group.grupo.CDGRUPROMOC];
		return comboCart.QTPRGRUPPROMOC - ApplicationContext.MenuService.getTotalCurrentComboProducts(comboCart.products);
	};

	this.getProductsGroupQuantity = (group) => {
		const cart = ApplicationContext.MenuService.getCart();
		return cart.filter(item => item.NMGRUPO === group.DESC).length;
	};

	this.showSelectedProductLabel = (product) => {
		const cart = ApplicationContext.MenuService.getCart();
		return cart.some(cartItem => cartItem.CDPRODUTO === product.CDPRODUTO);
	};

	this.showSelectedComboProductLabel = (group, product) => {
		let comboCart = widget.product.comboCart[group.CDGRUPROMOC];
		let productSelected = comboCart.products.find(cartItem => cartItem.CDPRODUTO === product.CDPRODUTO);
		return !!productSelected;
	};
}

// FILE: src/controller/ProductDetailController.js
function ProductDetailController($scope, $sce, $sceDelegate, ScreenService) {
	var self = this;
	var widget = $scope.widget;
	self.product = widget.product;

	this.decreaseQuantity = function() {
		if (self.product.QUANTIDADE > 1) {
			self.product.QUANTIDADE--;
		}
	};

	this.increaseQuantity = function() {
		if (self.product.QUANTIDADE < 10) {
			self.product.QUANTIDADE++;
		}
	};

	this.openPeronalizationsModal = function(modalName, modalTemplate, personalizations) {
		var personalizeModalActions = [
			{
				"label": "Voltar",
				"showAsAction": "back",
				"isVisible": true,
				"showOnForm": true,
				"showOnList": true,
				"events": [
					{
						"name": "ActionEvent",
						"code": "ScreenService.closePopup();",
					}
				]
			},
			{
				"label": "Salvar",
				"showAsAction": "never",
				"isVisible": true,
				"showOnForm": true,
				"showOnList": true,
				"events": [
					{
						"name": "ActionEvent",
						"code": "ScreenService.closePopup();",
					}
				]
			}
	    ];

		var popupWidget = metaDataFactory.widgetFactory(
			{
				"name": "personalizeModal",
				"container": widget.container,
				"parentWidget": widget,
				"label": modalName,
				"showAsModal": true,
				"template": `odh-menu#${modalTemplate}.html`,
				"isVisible": true,
				"popupNoBlock": false,
				"actions": personalizeModalActions,
				"personalizations": personalizations ? personalizations : [],
				"showFooter": false
			}
		);

		ScreenService.openPopup(popupWidget);
	};

	this.getTotalProductPrice = function() {
		return this.product.QUANTIDADE * parseFloat(this.product.VRPRECITEM);
	};

	this.showPersonalizations = function() {
		return self.product.personalizations.ingredients.length > 0 || self.product.personalizations.observations.length > 0 || widget.parentWidget.showCustomObservation;
	};

	$scope.loadProductImg = function(){
		return $sce.trustAsResourceUrl(self.product.DSENDEIMG);
	};
}